import Push from 'push.js';
export const init = () => {
    Push.config({
        serviceWorker: './service-worker.js',
    });
};
export const focusWindow = () => { };
export const requestNotificationPermissions = () => {
    Push.Permission.request(undefined, () => {
        // this is needed to not throw an error when the permission is denied
    });
};
export const notify = (id, title, _description, params) => {
    const { icon, timeout } = params;
    Push.create(title, {
        tag: id,
        icon,
        timeout: (timeout || 0) * 1000,
    }).catch(() => {
        // this is needed to not throw an error when the permission is denied
    });
};
export const closeNotification = (id) => {
    Push.close(id);
};
export const hasLoggedIn = (_teams) => { };
export const hasLoggedOut = () => { };
export const hasSelectedTeam = (_customerId) => { };
export const setRequestReferer = (_referer) => { };
